import compactObject from '../../util/compactObject';
import fullNameParts from '../../util/fullNameParts';
import getFieldValue from '../elements/getFieldValue';
import getForm from '../elements/getForm';
import submitForm from './submitForm';

function getFormUrl() {
  return `https://${process.env.API_HOST}/vtwa/v3/tutor_applicants/validations`;
}

function getFormData(form) {
  const [firstName, lastName] = fullNameParts(
    getFieldValue(form, 'full_name') || '',
    false
  );
  const data = {
    email: getFieldValue(form, 'email'),
    first_name: firstName,
    last_name: lastName,
    zip_code: getFieldValue(form, 'zip_code'),
  };

  return compactObject(data);
}

function getFieldData(form, field) {
  return { [field]: getFieldValue(form, field) };
}

export async function checkTutorPhoneNumber(step) {
  return checkTutorDetails(step, 'phone_number');
}

export default async function checkTutorDetails(step, targetField = '') {
  const form = getForm(step);
  const formData = (targetField === '') ? getFormData(form) : getFieldData(form, targetField);
  const formVersion = getFieldValue(form, 'leadform');
  const url = getFormUrl();

  await submitForm(url, { formData: formData, formVersion: formVersion }).catch((e) => {
    const errMessage = e.rootCauses?.length ? 
      `Validation failed: ${e.rootCauses[0]}.` : 
      'Sorry, something went wrong';
    throw new Error(errMessage);
  });
}
